import type React from 'react';

import { Separator, Text } from '@change/ds-core-ui';

export const InfoSection: React.FC = () => {
	return (
		<div className="container px-2 md:px-4">
			<div className="grid grid-cols-1 gap-4 pt-10 pb-8 md:grid-cols-3">
				{['35+ Organizations', '$5+ Million', '17+ States and DC'].map((text) => (
					<div
						key={text}
						className="[&:not(:last-child)]:after:border-neutral-grey400 relative text-center [&:not(:last-child)]:after:absolute [&:not(:last-child)]:after:top-1/2 [&:not(:last-child)]:after:-right-2 [&:not(:last-child)]:after:hidden [&:not(:last-child)]:after:h-5 [&:not(:last-child)]:after:-translate-y-1/2 [&:not(:last-child)]:after:border-r [&:not(:last-child)]:after:content-[''] md:[&:not(:last-child)]:after:block"
					>
						<Text size="large">{text}</Text>
					</div>
				))}
			</div>
			<Separator className="mb-10 block md:hidden" />
			<div className="pb-8">
				<Text variant="heading" as="h2" size="large">
					Racial justice petitions are the largest in Change.org’s history.
				</Text>
				<div className="py-4">
					<Text as="div">
						Last year’s racial justice reckoning prompted two students to start petitions demanding justice for George
						Floyd and Breonna Taylor. More than 30 million signers around the world joined their call, making them the
						largest petitions our site has ever seen. Since then, Change.org has pledged millions from those petitions
						to support Black-led organizations and movements that empower racial justice work.
					</Text>
					<br />
					<Text as="div">
						Through a process, under the guidance of North Star Fund, a New York-based community foundation, more than
						35 Black-led organizations were selected across the United States. Each grant will support their work on the
						frontlines disrupting anti-Blackness and empowering communities of color.
					</Text>
					<br />
					<Text as="div">
						Black-led organizations are statistically overwhelmingly excluded from philanthropic support. The Racial
						Justice Fund is part of Change.org’s commitment to equitable philanthropic practices and systemic change.
						The work has only just begun.
					</Text>
				</div>
			</div>
		</div>
	);
};
